import React, { useContext, useEffect, useMemo, useCallback } from "react";
import { useHistory } from "react-router-dom";

import {
  Context,
  fetchClasses,
  fetchKlassIdsWithActiveLearningMaterials,
  chooseTextbookPath,
  activeLearningTextbookPath,
  textbookPath,
} from "../../../teacherStore";
import { parseQueryParams } from "../../../libs/Util";
import SelectClass from "../../../templates/Select/Class";
import { EFFECTIVE_YEAR } from "../../../constants/year";

export default () => {
  const { state, dispatch } = useContext(Context);
  const history = useHistory();
  const queryParams = parseQueryParams();
  const classListInParams = queryParams["classList"];
  const isActiveLearningParam = queryParams["isActiveLearning"] === "true";
  const classes = isActiveLearningParam
    ? state.klass_ids_with_active_learning_materials
    : state.classes;

  useEffect(() => {
    dispatch(fetchClasses());
    dispatch(fetchKlassIdsWithActiveLearningMaterials());
  }, [dispatch]);

  const selectedClassIds: number[] = useMemo(
    () =>
      classListInParams
        ? classListInParams.split(",").map((classID: string) => Number(classID))
        : [],
    [classListInParams],
  );

  const selectedClasses = useMemo(
    () => classes.filter(c => selectedClassIds.includes(c.id)),
    [classes, selectedClassIds],
  );

  const replacePath = useCallback(
    (ids: number[]) => {
      const activeLearningParam = isActiveLearningParam
        ? "&isActiveLearning=true"
        : "";
      history.replace(
        `${textbookPath}${chooseTextbookPath}?classList=${ids.join(
          ",",
        )}${activeLearningParam}`,
      );
    },
    [history, isActiveLearningParam],
  );

  const selectClass = (id: number) => {
    const ids = classes
      .filter(cls => cls.id === id || selectedClassIds.includes(cls.id))
      .map(cls => cls.id);
    replacePath(ids);
  };

  const removeClass = (id: number) => {
    const ids = selectedClassIds.filter(clsId => clsId !== id);
    replacePath(ids);
  };

  const goToTextbookWithSelectedClasses = useCallback(() => {
    const classListParam = `?classList=${selectedClassIds.join(",")}`;
    const path = isActiveLearningParam
      ? `${activeLearningTextbookPath}${classListParam}&code=${state.available_item_codes[0]}`
      : `${textbookPath}${classListParam}`;
    history.push(path);
  }, [
    history,
    isActiveLearningParam,
    selectedClassIds,
    state.available_item_codes,
  ]);

  return (
    <SelectClass
      classes={classes}
      isMultiSelect
      selectedClassIds={selectedClassIds}
      selectedClasses={selectedClasses}
      onChooseClass={id => {
        if (selectedClassIds.includes(id)) {
          removeClass(id);
        } else {
          selectClass(id);
        }
      }}
      onRemoveClass={removeClass}
      goToTextbookWithSelectedClasses={goToTextbookWithSelectedClasses}
      isShowExchangeYearLink={
        state.is_manager && state.current_year < EFFECTIVE_YEAR
      }
    />
  );
};
